<!-- Register route: path: '/org/:sub_level/:id/wisdom-care-volunteers', component: WisdomCareVolunteersList -->
<template>

    <!-- Filter Section with Accordion -->
    <div class="section inset mt-1 mb-1">
        <div class="accordion" id="accordionWisdomCareFilter">
            <div class="accordion-item">
                <h2 class="accordion-header">
                    <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#wisdomCareFilterAccordion" aria-expanded="false">
                        <ion-icon name="filter-outline"></ion-icon>
                        Filter
                    </button>
                </h2>
                <div id="wisdomCareFilterAccordion" class="accordion-collapse collapse" :class="hasActiveFilters ? 'show' : ''" data-bs-parent="#accordionWisdomCareFilter">
                    <div class="accordion-body">
                        <div v-if="showDistrictFilter" class="form-group">
                            <div class="input-wrapper">
                                <label class="label" for="filter_district">District</label>
                                <select class="form-control custom-select" v-model="filters.district" @change="onDistrictFilterChange">
                                    <option value="">---All---</option>
                                    <option v-for="d in districtsList" :key="d.id" :value="d.id">{{ d.name }}</option>
                                </select>
                            </div>
                        </div>
                        <div v-if="showZoneFilter" class="form-group">
                            <div class="input-wrapper">
                                <label class="label" for="filter_zone">Zone</label>
                                <select class="form-control custom-select" v-model="filters.zone" @change="onZoneFilterChange">
                                    <option value="">---All---</option>
                                    <option v-for="z in zonesList" :key="z.id" :value="z.id">{{ z.name }}</option>
                                </select>
                            </div>
                        </div>
                        <div v-if="showUnitFilter" class="form-group">
                            <div class="input-wrapper">
                                <label class="label" for="filter_unit">Unit</label>
                                <select class="form-control custom-select" v-model="filters.unit">
                                    <option value="">---All---</option>
                                    <option v-for="u in unitsList" :key="u.id" :value="u.id">{{ u.name }}</option>
                                </select>
                            </div>
                        </div>
                        <!-- Advanced filter: pick several service categories at once (e.g. "trauma
                             care OR snake rescue") to quickly surface whoever's suitable for an
                             emergency, instead of checking one category at a time. -->
                        <div class="form-group" v-if="categories.length">
                            <div class="input-wrapper">
                                <label class="label">Service Categories</label>
                                <p class="text-muted mb-1" style="font-size:11px;" v-if="filters.service_category_ids.length">{{ filters.service_category_ids.length }} selected</p>
                                <div class="wc-filter-category-list">
                                    <div class="form-check mb-1 col-12" v-for="c in categories" :key="c.id">
                                        <input type="checkbox" class="form-check-input" :id="'filter_sc_' + c.id" :value="c.id" v-model="filters.service_category_ids" />
                                        <label class="form-check-label" :for="'filter_sc_' + c.id">{{ c.name }}<template v-if="c.name_mal"> ({{ c.name_mal }})</template></label>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="form-group" v-else>
                            <p class="text-muted mal-text" style="font-size:12px;">സേവന മേഖലകൾ ഒന്നും ചേർത്തിട്ടില്ല — പോർട്ടലിലെ Wisdom Care Service Categories പേജിൽ നിന്ന് ചേർക്കുക.</p>
                        </div>

                        <!-- Volunteers can also type a skill outside the catalog (see
                             WisdomCare.vue's "വേറെ മേഖല ടൈപ്പ് ചെയ്യുക" field) — those never show
                             up in the catalog list above, so surface them here from whatever
                             values volunteers have actually typed, matched the same OR-together way. -->
                        <div class="form-group" v-if="customSkillsList.length">
                            <div class="input-wrapper">
                                <label class="label">Custom Skills (user-added)</label>
                                <p class="text-muted mb-1" style="font-size:11px;" v-if="filters.custom_skills.length">{{ filters.custom_skills.length }} selected</p>
                                <div class="wc-filter-category-list">
                                    <div class="form-check mb-1 col-12" v-for="(s, idx) in customSkillsList" :key="'custom_' + idx">
                                        <input type="checkbox" class="form-check-input" :id="'filter_cs_' + idx" :value="s" v-model="filters.custom_skills" />
                                        <label class="form-check-label mal-text" :for="'filter_cs_' + idx">{{ s }}</label>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="form-group">
                            <div class="input-wrapper">
                                <label class="label" for="filter_verified">Verified</label>
                                <select class="form-control custom-select" v-model="filters.verified">
                                    <option value="">---All---</option>
                                    <option value="1">Verified</option>
                                    <option value="0">Not Verified</option>
                                </select>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-6">
                                <button type="button" class="btn btn-danger btn-sm me-1 mb-1" style="width: 100%;" @click="clearFilters">
                                    <ion-icon name="trash-bin-outline"></ion-icon>
                                    Clear
                                </button>
                            </div>
                            <div class="col-6">
                                <button type="button" class="btn btn-primary btn-sm me-1 mb-1" style="width: 100%;" @click="applyFilters">
                                    <ion-icon name="search-outline"></ion-icon>
                                    Filter
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <!-- Search -->
    <div class="search-section">
        <div class="search-box">
            <div class="input-wrapper">
                <input type="text" class="form-control search-input" v-model="search_query" @input="handleSearch" placeholder="പേര് / മൊബൈൽ തിരയൂ (Search by name or mobile)" autocomplete="off" />
                <ion-icon name="search-outline" class="search-icon"></ion-icon>
                <button type="button" class="clear-search-btn" v-if="search_query" @click="clearSearch">
                    <ion-icon name="close-circle"></ion-icon>
                </button>
            </div>
        </div>
    </div>

    <!-- Share the currently filtered list (not just this page) as a WhatsApp message — pulls a
         fresh unpaginated fetch under the same filters at click time, see shareListViaWhatsApp(). -->
    <div class="section mt-1 mb-1" v-if="!loading_list && volunteers.length">
        <button type="button" class="btn btn-success btn-sm btn-block wc-share-btn" :disabled="sharingList" @click="shareListViaWhatsApp">
            <span v-if="sharingList" class="spinner-border spinner-border-sm me-1"></span>
            <ion-icon v-else name="logo-whatsapp"></ion-icon>
            ലിസ്റ്റ് WhatsApp വഴി ഷെയർ ചെയ്യുക
        </button>
    </div>

    <div class="section text-center" v-if="loading_list">
        <div class="spinner-border text-secondary" role="status"></div>
    </div>

    <div class="section">
        <div class="card">
            <h4 class="text-center mt-1 mal-text error-feedback" v-if="!loading_list && message">{{ message }}</h4>
        </div>
    </div>

    <ul class="listview image-listview inset text" v-if="!loading_list">
        <li v-for="(v, index) in volunteers" :key="v.id">
            <div class="item-content wc-vol-row">
                <router-link :to="'/org/' + $route.params.sub_level + '/' + $route.params.id + '/wisdom-care-volunteers/' + v.id" class="item">
                    <span class="sl-no">{{ pagination.from + index }}</span>
                    <img src="assets/img/sample/avatar/avatar1.png" alt="image" class="image" />
                    <div class="in">
                        <div class="min-width-50">
                            <b>{{ v.name }}</b>
                            <span class="wc-verified-badge" :class="v.verified ? 'verified' : 'not-verified'">{{ v.verified ? '✓ Verified' : 'Not Verified' }}</span>
                            <footer class="text-primary">
                                {{ v.mobile }}
                                <span class="mal-text"><br>{{ v.district_name }} &middot; {{ v.zone_name }} &middot; {{ v.unit_name }}</span>
                            </footer>
                            <!-- Collapsed by default — long skill/category lists were making every
                                 row very tall; tap to reveal instead. -->
                            <div class="wc-vol-skills" v-if="hasSkills(v) && expandedIds.has(v.id)">
                                <span v-if="v.service_categories && v.service_categories.length" class="mal-text">{{ v.service_categories.join(', ') }}</span>
                                <span v-if="v.custom_skills && v.custom_skills.length" class="mal-text wc-custom-skill-line">{{ v.custom_skills.join(', ') }}</span>
                            </div>
                            <a v-if="hasSkills(v)" href="javascript:void(0)" class="wc-vol-toggle mal-text" @click.stop.prevent="toggleExpand(v.id)">
                                {{ expandedIds.has(v.id) ? 'ചുരുക്കുക' : 'കൂടുതൽ കാണുക' }}
                                <ion-icon :name="expandedIds.has(v.id) ? 'chevron-up-outline' : 'chevron-down-outline'"></ion-icon>
                            </a>
                        </div>
                    </div>
                </router-link>
                <div class="wc-vol-actions">
                    <a :href="'tel:' + v.mobile" class="wc-vol-action-btn call" title="Call" @click.stop>
                        <ion-icon name="call"></ion-icon>
                    </a>
                    <a :href="'https://wa.me/91' + v.mobile" target="_blank" class="wc-vol-action-btn whatsapp" title="WhatsApp" @click.stop>
                        <ion-icon name="logo-whatsapp"></ion-icon>
                    </a>
                </div>
            </div>
        </li>
    </ul>

    <div class="section mt-2" v-if="!loading_list">
        <vue-awesome-paginate
            v-if="pagination.total > 0"
            :total-items="pagination.total"
            :items-per-page="pagination.per_page"
            :max-pages-shown="3"
            v-model="pagination.current_page"
            :on-click="handlePageChange"
            :show-ending-buttons="true"
            :show-breakpoint-buttons="false"
        />
    </div>
</template>

<script>
import UserService from '../../services/user.service';

export default {
    name: 'WisdomCareVolunteersList',
    data() {
        return {
            user_level: null,
            loading_list: false,
            message: '',
            search_query: '',
            search_timeout: null,
            volunteers: [],
            pagination: { current_page: 1, total: 0, per_page: 20, from: 1 },
            filters: { district: '', zone: '', unit: '', service_category_ids: [], custom_skills: [], verified: '' },
            districtsList: [],
            zonesList: [],
            unitsList: [],
            categories: [],
            customSkillsList: [],
            expandedIds: new Set(),
            sharingList: false,
        };
    },
    computed: {
        currentUser() {
            return this.$store.state.auth.user;
        },
        showDistrictFilter() {
            return this.user_level === 1;
        },
        showZoneFilter() {
            return this.user_level === 1 || this.user_level === 2;
        },
        showUnitFilter() {
            return this.user_level === 1 || this.user_level === 2 || this.user_level === 3;
        },
        hasActiveFilters() {
            return this.filters.district || this.filters.zone || this.filters.unit || this.filters.service_category_ids.length || this.filters.custom_skills.length || this.filters.verified !== '';
        },
    },
    mounted() {
        if (!this.currentUser) {
            location.replace('/');
            return;
        }
        this.user_level = parseInt(this.$route.params.sub_level);
        this.$root.updateParent('Wisdom Care Volunteers');
        this.loadFilterData();
        this.loadCategories();
        this.loadCustomSkillsList();
        this.getVolunteersList(1);
    },
    methods: {
        loadCategories() {
            UserService.authPostRequest('wisdom-care/get-service-categories', {}).then((response) => {
                if (response.data.status === 'success') {
                    this.categories = response.data.data || [];
                }
            }).catch(() => {});
        },
        loadCustomSkillsList() {
            UserService.authPostRequest('wisdom-care/get-custom-skills-list', {}).then((response) => {
                if (response.data.status === 'success') {
                    this.customSkillsList = response.data.data || [];
                }
            }).catch(() => {});
        },
        async loadFilterData() {
            try {
                if (this.user_level === 1) {
                    const resp = await UserService.authPostRequest('get-district-by-id', {});
                    this.districtsList = resp.data?.data?.list || [];
                }
                if (this.user_level === 2) {
                    const districtId = parseInt(this.$route.params.id);
                    if (districtId) {
                        const resp = await UserService.authPostRequest('get-zone-by-id', { district_id: districtId });
                        this.zonesList = resp.data?.data?.list || [];
                    }
                }
                if (this.user_level === 3) {
                    const zoneId = parseInt(this.$route.params.id);
                    if (zoneId) {
                        const resp = await UserService.authPostRequest('get-unit-by-id', { zone_id: zoneId });
                        this.unitsList = resp.data?.data?.list || [];
                    }
                }
            } catch (e) {
                // ignore — filter dropdowns just stay empty
            }
        },
        async onDistrictFilterChange() {
            this.filters.zone = '';
            this.filters.unit = '';
            this.zonesList = [];
            this.unitsList = [];
            if (!this.filters.district) return;
            const resp = await UserService.authPostRequest('get-zone-by-id', { district_id: parseInt(this.filters.district) });
            this.zonesList = resp.data?.data?.list || [];
        },
        async onZoneFilterChange() {
            this.filters.unit = '';
            this.unitsList = [];
            if (!this.filters.zone) return;
            const resp = await UserService.authPostRequest('get-unit-by-id', { zone_id: parseInt(this.filters.zone) });
            this.unitsList = resp.data?.data?.list || [];
        },
        applyFilters() {
            this.pagination.current_page = 1;
            this.getVolunteersList(1);
        },
        clearFilters() {
            this.filters = { district: '', zone: '', unit: '', service_category_ids: [], custom_skills: [], verified: '' };
            this.zonesList = this.user_level === 1 ? [] : this.zonesList;
            this.unitsList = this.user_level <= 2 ? [] : this.unitsList;
            this.pagination.current_page = 1;
            this.getVolunteersList(1);
        },
        getVolunteersList(page = 1) {
            this.loading_list = true;
            UserService.authPostRequest('wisdom-care/get-volunteers', {
                sub_level_type: this.user_level,
                id: this.user_level === 1 ? null : parseInt(this.$route.params.id),
                page,
                per_page: 20,
                q: this.search_query || '',
                filter_district_id: this.filters.district ? parseInt(this.filters.district) : null,
                filter_zone_id: this.filters.zone ? parseInt(this.filters.zone) : null,
                filter_unit_id: this.filters.unit ? parseInt(this.filters.unit) : null,
                filter_service_category_ids: this.filters.service_category_ids.length ? this.filters.service_category_ids : null,
                filter_custom_skills: this.filters.custom_skills.length ? this.filters.custom_skills : null,
                filter_verified: this.filters.verified !== '' ? parseInt(this.filters.verified) : null,
            }).then(
                (response) => {
                    this.loading_list = false;
                    if (response.data.status === 'success' && response.data.data && response.data.data.list) {
                        const paginatedList = response.data.data.list;
                        this.volunteers = paginatedList.data || [];
                        this.pagination = {
                            current_page: paginatedList.current_page || page,
                            total: paginatedList.total || 0,
                            per_page: paginatedList.per_page || 20,
                            from: paginatedList.from || 1,
                        };
                        this.message = this.volunteers.length ? '' : 'വളണ്ടിയർമാരെ ഒന്നും കണ്ടെത്തിയില്ല.';
                    } else {
                        this.volunteers = [];
                        this.message = response.data.message || 'വളണ്ടിയർമാരെ ഒന്നും കണ്ടെത്തിയില്ല.';
                    }
                },
                () => {
                    this.loading_list = false;
                    this.volunteers = [];
                    this.message = 'ലോഡ് ചെയ്യുന്നതിൽ പിശക്.';
                }
            );
        },
        handlePageChange(page) {
            this.pagination.current_page = page;
            this.getVolunteersList(page);
        },
        handleSearch() {
            if (this.search_timeout) clearTimeout(this.search_timeout);
            this.search_timeout = setTimeout(() => {
                this.pagination.current_page = 1;
                this.getVolunteersList(1);
            }, 500);
        },
        clearSearch() {
            this.search_query = '';
            this.pagination.current_page = 1;
            this.getVolunteersList(1);
        },
        // ---- Collapsed rows ----
        hasSkills(v) {
            return (v.service_categories && v.service_categories.length) || (v.custom_skills && v.custom_skills.length);
        },
        toggleExpand(id) {
            if (this.expandedIds.has(id)) {
                this.expandedIds.delete(id);
            } else {
                this.expandedIds.add(id);
            }
        },
        // ---- Share the filtered list via WhatsApp ----
        // Re-fetches under the current filters with a large per_page — the list on screen is
        // just the current page, but sharing "the filtered list" should mean everyone matching,
        // not only whatever happens to be paginated in right now.
        async shareListViaWhatsApp() {
            this.sharingList = true;
            try {
                const response = await UserService.authPostRequest('wisdom-care/get-volunteers', {
                    sub_level_type: this.user_level,
                    id: this.user_level === 1 ? null : parseInt(this.$route.params.id),
                    page: 1,
                    per_page: 500,
                    q: this.search_query || '',
                    filter_district_id: this.filters.district ? parseInt(this.filters.district) : null,
                    filter_zone_id: this.filters.zone ? parseInt(this.filters.zone) : null,
                    filter_unit_id: this.filters.unit ? parseInt(this.filters.unit) : null,
                    filter_service_category_ids: this.filters.service_category_ids.length ? this.filters.service_category_ids : null,
                    filter_custom_skills: this.filters.custom_skills.length ? this.filters.custom_skills : null,
                    filter_verified: this.filters.verified !== '' ? parseInt(this.filters.verified) : null,
                });
                if (response.data.status !== 'success') {
                    alert(response.data.message || 'ലിസ്റ്റ് ലോഡ് ചെയ്യാൻ കഴിഞ്ഞില്ല.');
                    return;
                }
                const list = (response.data.data.list && response.data.data.list.data) || [];
                this.openWhatsAppShare(list);
            } catch (e) {
                alert('എന്തോ തെറ്റ് സംഭവിച്ചു. ദയവായി വീണ്ടും ശ്രമിക്കുക.');
            } finally {
                this.sharingList = false;
            }
        },
        activeFilterSummary() {
            const parts = [];
            if (this.filters.district) {
                const d = this.districtsList.find((x) => x.id === parseInt(this.filters.district));
                if (d) parts.push('District: ' + d.name);
            }
            if (this.filters.zone) {
                const z = this.zonesList.find((x) => x.id === parseInt(this.filters.zone));
                if (z) parts.push('Zone: ' + z.name);
            }
            if (this.filters.unit) {
                const u = this.unitsList.find((x) => x.id === parseInt(this.filters.unit));
                if (u) parts.push('Unit: ' + u.name);
            }
            if (this.filters.service_category_ids.length) {
                const names = this.filters.service_category_ids
                    .map((id) => this.categories.find((c) => c.id === id))
                    .filter(Boolean)
                    .map((c) => c.name);
                if (names.length) parts.push('Categories: ' + names.join(', '));
            }
            if (this.filters.custom_skills.length) {
                parts.push('Skills: ' + this.filters.custom_skills.join(', '));
            }
            if (this.filters.verified !== '') {
                parts.push(this.filters.verified === '1' ? 'Verified only' : 'Not Verified only');
            }
            if (this.search_query) {
                parts.push('Search: "' + this.search_query + '"');
            }
            return parts;
        },
        openWhatsAppShare(list) {
            const MAX_ENTRIES = 60;
            let text = '*Wisdom Care Volunteers*\n';
            const filterParts = this.activeFilterSummary();
            if (filterParts.length) {
                text += '_Filters:_ ' + filterParts.join(' | ') + '\n';
            }
            text += `*Total: ${list.length} volunteer${list.length === 1 ? '' : 's'}*\n`;
            text += '━━━━━━━━━━━━━━━━━━━━\n\n';

            const shown = list.slice(0, MAX_ENTRIES);
            shown.forEach((v, idx) => {
                text += `${idx + 1}. *${v.name}*${v.verified ? ' ✓' : ''}\n`;
                text += `   📞 ${v.mobile}\n`;
                text += `   📍 ${v.district_name} / ${v.zone_name} / ${v.unit_name}\n`;
                const skills = [...(v.service_categories || []), ...(v.custom_skills || [])];
                if (skills.length) {
                    text += `   🛠️ ${skills.join(', ')}\n`;
                }
                text += '\n';
            });
            if (list.length > MAX_ENTRIES) {
                text += `_...and ${list.length - MAX_ENTRIES} more (showing first ${MAX_ENTRIES})_\n\n`;
            }
            text += '━━━━━━━━━━━━━━━━━━━━\n';
            text += '*Generated from Wisdom Guide App*';

            const whatsappUrl = 'https://wa.me/?text=' + encodeURIComponent(text);
            window.open(whatsappUrl, '_blank');
        },
    },
};
</script>

<style scoped>
.wc-filter-category-list {
    max-height: 220px;
    overflow-y: auto;
    border: 1px solid #eef0f5;
    border-radius: 8px;
    padding: 8px 10px 2px;
}
.item-content {
    display: flex;
    align-items: center;
    width: 100%;
    position: relative;
    min-height: 60px;
    padding: 8px 0;
}
.item-content .item {
    flex: 1;
    min-width: 0;
    display: flex;
    align-items: center;
    padding-top: 11px;
    padding-bottom: 11px;
}
.item-content .item .in {
    display: flex;
    align-items: center;
    width: 100%;
    min-width: 0;
}
.item-content .sl-no {
    flex-shrink: 0;
    margin-right: 12px;
}
.wc-custom-skill-line {
    color: #7c3aed;
}

/* Row layout: the router-link (name/info) shares the row with a small Call/WhatsApp button
   pair instead of the old full-width tap target + chevron — both stay reachable without
   fighting each other for space. */
.wc-vol-row {
    align-items: flex-start;
    gap: 4px;
}
.wc-vol-actions {
    flex-shrink: 0;
    display: flex;
    flex-direction: column;
    gap: 6px;
    padding-top: 11px;
    padding-right: 4px;
}
.wc-vol-action-btn {
    width: 30px;
    height: 30px;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 15px;
    color: #fff;
}
.wc-vol-action-btn.call {
    background: #3b5bdb;
}
.wc-vol-action-btn.whatsapp {
    background: #25d366;
}

/* Collapsed-by-default skill list — long category text was making every row very tall. */
.wc-vol-skills {
    margin-top: 2px;
    font-size: 12.5px;
    color: #6c757d;
}
.wc-vol-toggle {
    display: inline-flex;
    align-items: center;
    gap: 2px;
    margin-top: 3px;
    font-size: 11.5px;
    font-weight: 600;
    color: #3b5bdb;
}
.wc-vol-toggle ion-icon {
    font-size: 13px;
}

.wc-share-btn {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 6px;
}
.wc-verified-badge {
    display: inline-block;
    margin-left: 6px;
    padding: 1px 8px;
    border-radius: 100px;
    font-size: 10.5px;
    font-weight: 700;
    vertical-align: middle;
}
.wc-verified-badge.verified {
    background: #e6f7ec;
    color: #15803d;
}
.wc-verified-badge.not-verified {
    background: #f3f4f6;
    color: #6b7280;
}
.search-section {
    padding: 4px 16px 8px 16px;
}
.search-box .input-wrapper {
    position: relative;
}
.search-input {
    padding-left: 36px;
    padding-right: 36px;
}
.search-icon {
    position: absolute;
    left: 10px;
    top: 50%;
    transform: translateY(-50%);
    color: #6b7280;
}
.clear-search-btn {
    position: absolute;
    right: 8px;
    top: 50%;
    transform: translateY(-50%);
    background: none;
    border: none;
    padding: 4px;
    color: #6b7280;
}
</style>
